import { render, staticRenderFns } from "./TabHeaderPopup.vue?vue&type=template&id=2ee4317b"
import script from "./TabHeaderPopup.vue?vue&type=script&lang=js"
export * from "./TabHeaderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports